<!-- Backdrop -->
<div class="ai-backdrop" *ngIf="isOpen" (click)="closed.emit()"></div>

<div class="ai-drawer" [class.ai-drawer--open]="isOpen" role="dialog" aria-label="Aluguloo AI Consultant">

  <!-- Header -->
  <div class="ai-drawer__header">
    <div class="ai-header-glow" aria-hidden="true"></div>
    <div class="ai-drawer__header-brand">
      <div class="ai-drawer__avatar">
        <div class="ai-avatar__ring" aria-hidden="true"></div>
        <img src="assets/alugulooailogo.jpeg" alt="Aluguloo AI"
          style="width:32px;height:32px;border-radius:10px;object-fit:cover;display:block;">
        <span class="ai-avatar__pulse" aria-hidden="true"></span>
      </div>
      <div class="ai-drawer__header-text">
        <span class="ai-drawer__title">Aluguloo AI</span>
        <span class="ai-drawer__subtitle">Equipment Consultant</span>
      </div>
    </div>
    <div class="ai-drawer__header-actions">
      <span class="ai-drawer__status-badge">
        <span class="ai-drawer__status-dot"></span>Online
      </span>
      <button class="ai-drawer__close" (click)="closed.emit()" aria-label="Close AI Consultant">
        <svg width="14" height="14" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M5 5L15 15M15 5L5 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Messages -->
  <div class="ai-drawer__messages" #messagesContainer>

    <!-- Welcome -->
    <div class="ai-welcome" *ngIf="messages.length <= 1">
      <div class="ai-welcome__hero">
        <div class="ai-welcome__icon-wrap" aria-hidden="true">
          <div class="ai-welcome__icon-bg"></div>
          <svg width="28" height="28" viewBox="0 0 48 48" fill="none">
            <path d="M24 10L27 19L36 21L27 23L24 32L21 23L12 21L21 19L24 10Z" fill="#55C7F3" />
            <path d="M37 8L38.5 12.5L43 14L38.5 15.5L37 20L35.5 15.5L31 14L35.5 12.5L37 8Z" fill="#3BB7E8"
              opacity="0.8" />
            <circle cx="13" cy="35" r="2.5" fill="#55C7F3" opacity="0.45" />
          </svg>
        </div>
        <h2 class="ai-welcome__title">How can I help you today?</h2>
        <p class="ai-welcome__subtitle">Tell me about your project and I'll recommend the best equipment available.</p>
      </div>
    </div>

    <!-- Chat loop -->
    <ng-container *ngFor="let msg of messages; let i = index; trackBy: trackByIndex">

      <!-- AI plain text message (including location-prompt messages) -->
      <div class="ai-message ai-message--ai"
        *ngIf="msg.role === 'ai' && !$any(msg).recommendationCard && !$any(msg).refinedResponse">
        <div class="ai-message__avatar" *ngIf="showAvatar(i)" aria-hidden="true">
          <svg width="13" height="13" viewBox="0 0 28 28" fill="none">
            <path d="M14 3C14 3 8 7 8 14C8 17.5 10 20.5 14 22C18 20.5 20 17.5 20 14C20 7 14 3 14 3Z" fill="#55C7F3" />
            <circle cx="14" cy="14" r="3" fill="#55C7F3" />
          </svg>
        </div>
        <div class="ai-message__avatar-spacer" *ngIf="!showAvatar(i)" aria-hidden="true"></div>
        <div class="ai-message__body">
          <div class="ai-message__bubble">{{ msg.text }}</div>
          <time class="ai-message__time">{{ msg.timestamp | date:'h:mm a' }}</time>

          <!-- ── LOCATION PICKER (only on awaitingLocation messages) ── -->
          <div *ngIf="$any(msg).awaitingLocation" class="location-picker">
            <div class="location-picker__label">Select your emirate</div>
            <div class="location-picker__grid">
              <button *ngFor="let emirate of EMIRATES" class="location-pill" type="button"
                (click)="selectEmirate(emirate)">
                {{ emirate }}
              </button>
              <button class="location-pill location-pill--any" type="button" (click)="selectEmirate('UAE')">
                Anywhere in UAE
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- ── RECOMMENDATION FLOW CONTAINER ── -->
      <ng-container *ngIf="msg.role === 'ai' && $any(msg).recommendationCard as card">

        <!-- SECTION 1 — PROJECT ANALYSIS (compact 2 lines) -->
        <div class="analysis-card">
          <span class="analysis-card__label">Project Analysis</span>
          <h3 class="analysis-card__title">{{ card.projectTitle }}</h3>
          <div class="analysis-card__chips">
            <span class="analysis-chip analysis-chip--location" *ngIf="card.location">
              <svg width="9" height="9" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                <path
                  d="M6 1C4.07 1 2.5 2.57 2.5 4.5C2.5 7.5 6 11 6 11S9.5 7.5 9.5 4.5C9.5 2.57 7.93 1 6 1ZM6 5.75C5.31 5.75 4.75 5.19 4.75 4.5C4.75 3.81 5.31 3.25 6 3.25C6.69 3.25 7.25 3.81 7.25 4.5C7.25 5.19 6.69 5.75 6 5.75Z"
                  fill="currentColor" />
              </svg>
              {{ card.location }}
            </span>
          </div>
        </div>

        <!-- SECTION 2 — RECOMMENDATION SUMMARY (one sentence) -->
        <div class="recommendation-summary" *ngIf="card.recommendationSummary">
          <span class="recommendation-summary__label">Recommendation</span>
          <p class="recommendation-summary__text">{{ card.recommendationSummary }}</p>
        </div>
        z
        <!-- SECTION 3 — INVENTORY TRANSPARENCY -->
        <div class="inventory-transparency"
          *ngIf="card.recommendedCount && card.availableCount && card.recommendedCount > card.availableCount">
          <!-- <div class="inventory-transparency__row">
            <span class="inventory-transparency__label">AI Recommended:</span>
            <span class="inventory-transparency__value">{{ card.recommendedCount }} Equipment Types</span>
          </div> -->
          <div class="inventory-transparency__row">
            <span class="inventory-transparency__label">Marketplace Available:</span>
            <span class="inventory-transparency__value inventory-transparency__value--available">{{ card.availableCount
              }} Equipment Types</span>
          </div>
        </div>

        <!-- SECTION 4 — RECOMMENDED EQUIPMENT FLEET -->
        <div class="recommendation-header">
          <h4 class="recommendation-header__title">Recommended Equipment Fleet</h4>
        </div>

        <!-- SECTION 5 — BEST MATCH CARDS -->
        <div class="equipment-cards-grid">
          <div *ngFor="let grp of card.groups; trackBy: trackByGroup" class="best-match-card">
            <div class="best-match-card__header">
              <span class="best-match-card__category">{{ grp.type }}</span>
              <span class="best-match-card__badge">Best Match</span>
            </div>
            <div class="best-match-card__body" *ngIf="grp.bestMatch as bm">
              <div class="best-match-card__main">
                <div class="best-match-card__image" *ngIf="bm.images?.[0]">
                  <img [src]="bm.images[0]" [alt]="bm.name || (bm.brand + ' ' + bm.model)" loading="lazy"
                    onerror="this.style.display='none'">
                </div>
                <div class="best-match-card__info">
                  <span class="best-match-card__name">{{ bm.name || (bm.brand + ' ' + bm.model) }}</span>
                  <span class="best-match-card__sub">{{ bm.brand }} · {{ bm.model }}</span>
                  <div class="best-match-card__meta">
                    <span class="best-match-card__location" *ngIf="bm.emirate">
                      <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
                        <path
                          d="M6 1C4.07 1 2.5 2.57 2.5 4.5C2.5 7.5 6 11 6 11C6 11 9.5 7.5 9.5 4.5C9.5 2.57 7.93 1 6 1ZM6 5.75C5.31 5.75 4.75 5.19 4.75 4.5C4.75 3.81 5.31 3.25 6 3.25C6.69 3.25 7.25 3.81 7.25 4.5C7.25 5.19 6.69 5.75 6 5.75Z"
                          fill="currentColor" />
                      </svg>
                      {{ bm.emirate }}
                    </span>
                    <span class="best-match-card__rate" *ngIf="bm.dailyRate">AED {{ bm.dailyRate | number }}/day</span>
                  </div>
                </div>
              </div>
              <div class="best-match-card__reason" *ngIf="grp.whyNeeded">
                <span class="best-match-card__reason-label">Why Recommended</span>
                <span class="best-match-card__reason-text">{{ grp.whyNeeded }}</span>
              </div>
            </div>
            <div class="best-match-card__footer">
              <button class="best-match-card__browse" (click)="viewListing(grp.bestMatch?.id || '')">View
                Listing</button>
              <button class="best-match-card__more" *ngIf="grp.alternativeCount > 0"
                (click)="viewEquipmentType(grp.type, card.location)">
                +{{ grp.alternativeCount }} More {{ grp.type }}s Available
              </button>
            </div>
          </div>
        </div>

        <!-- SECTION 6 — ESTIMATED FLEET RENTAL -->
        <div class="fleet-rental" *ngIf="$any(card).rentalSummary">
          <span class="fleet-rental__label">Estimated Fleet Rental</span>
          <div class="fleet-rental__rates">
            <div class="fleet-rental__row">
              <span>Daily</span>
              <strong>AED {{ $any(card).rentalSummary.dailyRate | number }}/day</strong>
            </div>
            <div class="fleet-rental__row">
              <span>Weekly</span>
              <strong>AED {{ $any(card).rentalSummary.weeklyRate | number }}/week</strong>
            </div>
            <div class="fleet-rental__row">
              <span>Monthly</span>
              <strong>AED {{ $any(card).rentalSummary.monthlyRate | number }}/month</strong>
            </div>
          </div>
        </div>

        <!-- SECTION 7 — REFINE RECOMMENDATION (only action) -->
        <div class="action-section">
          <button class="rec-action-btn rec-action-btn--refine" (click)="setActiveRefinement(i)">Refine
            Recommendation</button>
        </div>

        <!-- SECTION 8 — REFINEMENT FORM -->
        <div *ngIf="activeRefinementIndex === i && !$any(msg).refinementSubmitted" class="refinement-section">
          <div class="refinement-card">
            <div class="refinement-card__header">Refine Recommendation</div>
            <div class="refinement-card__body">
              <div class="pm-field">
                <label class="pm-field__label">Project Duration</label>
                <div class="pm-pill-group">
                  <button *ngFor="let d of DURATIONS" class="pm-pill"
                    [class.pm-pill--active]="refinementData.duration === d" (click)="refinementData.duration = d"
                    type="button">{{ d }}</button>
                </div>
              </div>
              <div class="pm-field">
                <label class="pm-field__label">Soil / Surface Type</label>
                <div class="pm-pill-group">
                  <button *ngFor="let s of SOIL_TYPES" class="pm-pill"
                    [class.pm-pill--active]="refinementData.soilType === s" (click)="refinementData.soilType = s"
                    type="button">{{ s }}</button>
                </div>
              </div>
              <div class="pm-field">
                <label class="pm-field__label">Project Location</label>
                <div class="pm-select-wrap">
                  <select class="pm-select" [(ngModel)]="refinementData.emirate">
                    <option value="">Select emirate…</option>
                    <option *ngFor="let e of EMIRATES" [value]="e">{{ e }}</option>
                  </select>
                  <svg class="pm-select-icon" width="10" height="10" viewBox="0 0 12 12" fill="none">
                    <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
                  </svg>
                </div>
              </div>
              <div class="pm-field-row">
                <div class="pm-field pm-field--half">
                  <label class="pm-field__label">Operator Required</label>
                  <div class="pm-pill-group">
                    <button class="pm-pill" [class.pm-pill--active]="refinementData.operatorRequired === 'Yes'"
                      (click)="refinementData.operatorRequired = 'Yes'" type="button">Yes</button>
                    <button class="pm-pill" [class.pm-pill--active]="refinementData.operatorRequired === 'No'"
                      (click)="refinementData.operatorRequired = 'No'" type="button">No</button>
                  </div>
                </div>
                <div class="pm-field pm-field--half">
                  <label class="pm-field__label">Fuel Included</label>
                  <div class="pm-pill-group">
                    <button class="pm-pill" [class.pm-pill--active]="refinementData.fuelIncluded === 'Yes'"
                      (click)="refinementData.fuelIncluded = 'Yes'" type="button">Yes</button>
                    <button class="pm-pill" [class.pm-pill--active]="refinementData.fuelIncluded === 'No'"
                      (click)="refinementData.fuelIncluded = 'No'" type="button">No</button>
                  </div>
                </div>
              </div>
              <button class="pm-refine-submit" [disabled]="!refinementValid()"
                [class.pm-refine-submit--active]="refinementValid()" (click)="submitRefinement(i)" type="button">
                <svg width="13" height="13" viewBox="0 0 16 16" fill="none">
                  <path d="M2 8L14 8M10 4L14 8L10 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
                </svg>
                Refine Recommendation
              </button>
            </div>
          </div>
        </div>

      </ng-container>

      <!-- REFINED RESPONSE CARD -->
      <div *ngIf="msg.role === 'ai' && $any(msg).refinedResponse as refined" class="rec-card rec-card--refined">
        <div class="rec-card__header">
          <span class="rec-badge rec-badge--refined">
            <svg width="9" height="9" viewBox="0 0 12 12" fill="none">
              <path d="M2 6L5 9L10 3" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
            </svg>
            Refined Recommendation
          </span>
        </div>
        <div class="refined-body">
          <div class="refined-section" *ngIf="refined.primaryEquipment?.length">
            <span class="refined-label">Primary Equipment</span>
            <div class="refined-tags">
              <span *ngFor="let e of refined.primaryEquipment" class="refined-tag refined-tag--primary">{{ e }}</span>
            </div>
          </div>
          <div class="refined-section" *ngIf="refined.supportEquipment?.length">
            <span class="refined-label">Support Equipment</span>
            <div class="refined-tags">
              <span *ngFor="let e of refined.supportEquipment" class="refined-tag refined-tag--support">{{ e }}</span>
            </div>
          </div>
          <div class="refined-reason" *ngIf="refined.reasoning">
            <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
              <circle cx="6" cy="6" r="5" stroke="currentColor" stroke-width="1.2" />
              <path d="M6 5.5V8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" />
              <circle cx="6" cy="4" r="0.6" fill="currentColor" />
            </svg>
            {{ refined.reasoning }}
          </div>
        </div>
      </div>

      <!-- Plain equipment results -->
      <div
        *ngIf="msg.role === 'ai' && asEquipmentList(msg.equipmentResults).length > 0 && !$any(msg).recommendationCard && !$any(msg).refinedResponse"
        class="ai-results-section">
        <div class="ai-results-summary">
          <span class="ai-results-count">{{ (msg.equipmentResults ?? []).length }} Results Found</span>
          <div class="ai-results-chips" *ngIf="msg.searchMeta">
            <span class="ai-chip" *ngIf="msg.searchMeta.location">{{ msg.searchMeta.location }}</span>
            <span class="ai-chip" *ngIf="msg.searchMeta.category">{{ msg.searchMeta.category }}</span>
            <span class="ai-chip ai-chip--green">Available Now</span>
          </div>
        </div>
        <div class="ai-equipment-list">
          <div *ngFor="let item of asEquipmentList(msg.equipmentResults) | slice:0:5; trackBy: trackByEquipment"
            class="ai-equipment-card">
            <div class="ai-equipment-card__image">
              <img *ngIf="item.images?.[0]" [src]="item.images[0]" [alt]="item.brand + ' ' + item.model" loading="lazy"
                onerror="this.parentElement.innerHTML='<span class=\'eq-fallback\'>&#128679;</span>'">
              <span class="eq-fallback" *ngIf="!item.images?.[0]">&#128679;</span>
            </div>
            <div class="ai-equipment-card__info">
              <span class="ai-equipment-card__name">{{ item.name || (item.brand + ' ' + item.model) }}</span>
              <div class="ai-equipment-card__sub-row">
                <span class="ai-equipment-card__brand" *ngIf="item.brand">{{ item.brand }}</span>
                <span class="ai-equipment-card__model" *ngIf="item.model">· {{ item.model }}</span>
              </div>
              <div class="ai-equipment-card__location">
                <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M6 1C4.07 1 2.5 2.57 2.5 4.5C2.5 7.5 6 11 6 11C6 11 9.5 7.5 9.5 4.5C9.5 2.57 7.93 1 6 1ZM6 5.75C5.31 5.75 4.75 5.19 4.75 4.5C4.75 3.81 5.31 3.25 6 3.25C6.69 3.25 7.25 3.81 7.25 4.5C7.25 5.19 6.69 5.75 6 5.75Z"
                    fill="currentColor" />
                </svg>
                {{ item.emirate }}
              </div>
              <div class="ai-equipment-card__badges">
                <span class="ai-badge ai-badge--driver" *ngIf="item.withDriver === 'yes'">Driver</span>
                <span class="ai-badge ai-badge--fuel" *ngIf="item.withFuel === 'yes'">Fuel</span>
              </div>
            </div>
            <div class="ai-equipment-card__cta">
              <div class="ai-equipment-card__rate">
                <span class="ai-equipment-card__rate-value">AED {{ item.dailyRate | number }}</span>
                <span class="ai-equipment-card__rate-unit">/day</span>
              </div>
              <button class="ai-equipment-card__btn" (click)="viewListing(item.id)">View</button>
            </div>
          </div>
        </div>
      </div>

      <!-- User message -->
      <div *ngIf="msg.role === 'user'" class="ai-message ai-message--user">
        <div class="ai-message__body">
          <div class="ai-message__bubble">{{ msg.text }}</div>
          <time class="ai-message__time">{{ msg.timestamp | date:'h:mm a' }}</time>
        </div>
      </div>

    </ng-container>

    <!-- Thinking -->
    <div class="ai-message ai-message--ai" *ngIf="isTyping" aria-live="polite">
      <div class="ai-message__avatar" aria-hidden="true">
        <svg width="13" height="13" viewBox="0 0 28 28" fill="none">
          <path d="M14 3C14 3 8 7 8 14C8 17.5 10 20.5 14 22C18 20.5 20 17.5 20 14C20 7 14 3 14 3Z" fill="#55C7F3" />
          <circle cx="14" cy="14" r="3" fill="#55C7F3" />
        </svg>
      </div>
      <div class="ai-message__body">
        <div class="ai-message__bubble ai-thinking__bubble">
          <div class="ai-thinking__spinner" aria-hidden="true">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="rgba(85,199,243,0.2)" stroke-width="2.5" />
              <path d="M12 2C6.48 2 2 6.48 2 12" stroke="#55C7F3" stroke-width="2.5" stroke-linecap="round" />
            </svg>
          </div>
          <span class="ai-thinking__text">{{ thinkingMessage }}</span>
        </div>
      </div>
    </div>

  </div>

  <!-- Input Composer -->
  <div class="ai-drawer__input-area">
    <div class="ai-composer" [class.ai-composer--focused]="inputFocused" [class.ai-composer--disabled]="isTyping">
      <textarea class="ai-composer__textarea" [(ngModel)]="inputText" (keydown)="onKeydown($event)"
        (focus)="inputFocused = true" (blur)="inputFocused = false"
        placeholder="Describe your project or equipment need..." rows="1" [disabled]="isTyping">
      </textarea>
      <button class="ai-composer__send" (click)="send()" [disabled]="!inputText.trim() || isTyping"
        [class.ai-composer__send--active]="inputText.trim() && !isTyping">
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M3.5 10L2 3L18 10L2 17L3.5 10ZM3.5 10H11" stroke="currentColor" stroke-width="1.8"
            stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
    <p class="ai-composer__hint">Powered by Aluguloo AI · <kbd>⏎</kbd> to send</p>
  </div>

</div>